<template>
	<div :class="{ footer: true, footerShow: true }">
		<!--<div class="footerContent">
            <div class="footerContentMenu">
                <div class="footerContentMenu_list"
                v-for="(item,index) in menuList"
                :key="item.name"
                 @click="menuClick(index)">{{item.name}}</div>
            </div>
            <div class="footerContent_list">武汉芸希信息科技公司</div>
            <div class="footerContent_list">地址:湖北省武汉市江夏区关谷科技港2栋A单元5008</div>
            <div class="footerContent_list">电话:1234567890&nbsp;&nbsp;&nbsp;&nbsp;传真:1234567890</div>
            <div class="footerContent_list"><span style="color:#999;">版权所有©武汉芸希信息科技公司</span></div>
            <div class="footerContent_list">备案号:粤ICP备xxxxxxxxxx号</div>
        </div>-->
		<div class="footmain">
			<div class="baseinfo">
				<div id="seat"></div>
				<div class="infocontent">
					<div @click="goIndex(0)" style="cursor: pointer; text-align: center">
						<img src="../assets/yunthee/footerLogo.png" width="80%" height="auto" />
						<!-- <p id="call">call:18942912469</p> -->
					</div>
					<div style="text-align: center">
						<span
							@click="
								goLink('/serve/index', 0, 1, 0, '产品服务', '15347450641919420427')
							"
						>
							产品服务
						</span>
						<p
							@click="
								goLink('/serve/index', 0, 0, 1, '资产管理系统', '1534745061919420417')
							"
						>
							资产管理系统
						</p>
						<p
							@click="
								goLink('/serve/index', 0, 0, 1, '办公协同系统', '1534745061919420487')
							"
						>
							办公协同系统
						</p>
						<p
							@click="
								goLink('/serve/index', 0, 0, 1, '数字孪生系统', '1534745061919420477')
							"
						>
							数字孪生系统
						</p>
						<p
							@click="
								goLink('/serve/index', 0, 0, 2, '党建管理系统', '1534745061919420407')
							"
						>
							党建管理系统
						</p>
						<p
							@click="
								goLink('/serve/index', 0, 0, 2, '软件定制开发', '1534745061919420427')
							"
						>
							软件定制开发
						</p>
					</div>
					<div style="text-align: center">
						<span
							@click="goLink('/solve/index', 1, 1, 0, '解决方案', '1534082362617163778')"
						>
							解决方案
						</span>
						<p
							@click="goLink('/solve/index', 1, 0, 1, '智慧矿山', '1534082362617163778')"
						>
							智慧矿山
						</p>
						<p
							@click="goLink('/solve/index', 1, 0, 2, '智慧地灾', '1534082642075250689')"
						>
							智慧地灾
						</p>
						<p
							@click="goLink('/solve/index', 1, 0, 2, '智慧水务', '1534082859147259906')"
						>
							智慧水务
						</p>
					</div>
					<div style="text-align: center">
						<span @click="goLink('/case/index', 2, 1, 0, '产品案例')">产品案例</span>
					</div>
					<div style="text-align: center">
						<span @click="goLink('/joinus/advertise', 3, 1, 0, '关于我们')">
							关于我们
						</span>
						<p @click="goLink('/joinus/connet', 4, 0, 1, '公司简介')">公司简介</p>
						<p @click="goLink('/joinus/connet', 4, 0, 1, '团队活动')">团队活动</p>
						<p @click="goLink('/joinus/advertise', 4, 0, 1, '招贤纳士')">招贤纳士</p>
						<p @click="goLink('/joinus/connet', 4, 0, 1, '联系我们')">联系我们</p>
					</div>

					<div style="text-align: center; width: 100px">
						<img src="../assets/images/weixin04.jpg" width="80px" height="80px" />
						<p id="code">微信公众号</p>
					</div>
					<!--                    <div style="text-align:center;width: 100px">-->
					<!--                      <img src="../assets/images/weixin05.jpg" width="80px" height="80px"/>-->
					<!--                      <p id="code">扫一扫了解更多RPA资讯</p>-->
					<!--                    </div>-->
				</div>
			</div>
			<div class="frindLink">
				<ul>
					<li>友情链接：</li>
					<li v-for="(item, index) in linkList" :key="'lk' + index">
						<span>
							<a :href="item.url">{{ item.name }}</a>
						</span>
						<span v-if="index != linkList.length - 1">|</span>
					</li>
				</ul>
			</div>

			<div class="footerLine"></div>
			<div class="footerinfo" style="cursor: pointer">
				<span @click="goLinkWork">鄂ICP备2022003031号-1</span>
			</div>
		</div>
		<div class="phoneFooter">
			<div class="phoneWeixin">
				<img src="../assets/images/weixin04.jpg" width="30%" height="auto" />
				<!--                <img src="../assets/images/weixin05.jpg" width="30%" height="auto"/>-->
			</div>
			<div class="phoneLink">
				<span @click="phineLink('/home/index')">首页</span>
				<span>|</span>
				<span @click="phineLink('/cmpMainbusiness/finance')">公司主营</span>
				<span>|</span>
				<span @click="phineLink('/cusCase/caselist')">客户案例</span>
				<span>|</span>
				<span @click="phineLink('/joinus/connet')">联系我们</span>
			</div>
			<div class="phoneFooterInfo">
				<span>鄂CP备13006194号1@copyrightTHINGO思高科技</span>
			</div>
		</div>

		<div class="phoneBottom">
			<div class="botLink">
				<div class="itemLine" @click="phineLink('/home/index')">
					<img src="../assets/images/phoneHome.png" />
					<p>首页</p>
				</div>

				<div class="zipLine"></div>

				<div class="itemLine" @click="phineLink('/cmpMainbusiness/finance')">
					<img src="../assets/images/phoneMain02.png" />
					<p>公司主营</p>
				</div>

				<div class="zipLine"></div>

				<div class="itemLine" @click="phineLink('/cusCase/caselist')">
					<img src="../assets/images/PhoneCase.png" />
					<p>客户案例</p>
				</div>

				<div class="zipLine"></div>

				<div class="itemLine" @click="openDel">
					<img src="../assets/images/PhoneConenet.png" />
					<p>联系我们</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.phoneBottom {
	width: 100%;
	height: 70px;
	background: #ffffff;
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 30;
	display: none;
}
.phoneBottom .botLink {
	width: 100%;
	height: 70px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.phoneBottom .botLink .itemLine {
	width: 22%;
	height: 70px;
	text-align: center;
}
.phoneBottom .botLink .zipLine {
	width: 1px;
	height: 30px;
	background: #000b53;
	opacity: 0.1;
	margin: 0 5px;
}
.phoneBottom .botLink .itemLine p {
	margin: 0;
	font-size: 12px;
}
.phoneBottom .botLink .itemLine img {
	width: 30px;
	height: 30px;
	margin-top: 8px;
}

.frindLink {
	width: 80%;
	margin: 0 auto;
	height: auto;
	text-align: center;
	position: relative;
	top: -10px;
}
.frindLink ul {
	margin: 0;
	padding: 0;
}
.frindLink ul li {
	display: inline-block;
	list-style: none;
	color: #ffffff;
	opacity: 1;
	font-size: 14px;
	cursor: pointer;
}

.frindLink ul li a {
	text-decoration: none;
	color: #ffffff;
}

.frindLink ul li span {
	margin: 0 5px;
}

.footer {
	/* position: absolute;
    left:0;
    bottom:0;
    z-index:10; */
	width: 100%;
	background: #000b53;
}
.footer .footmain {
	width: 100%;
	height: auto;
}
.footer .footmain .baseinfo {
	width: 100%;
	height: auto;
	margin: 0 auto;
	padding-bottom: 50px;
}
.footer .footmain .baseinfo .infocontent {
	width: 70%;
	height: auto;
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
}
.footer .footmain .baseinfo .infocontent div {
	margin: 0 10px;
	width: 200px;
}
.footer .footmain .baseinfo .infocontent span {
	color: white;
	font-size: 18px;
	cursor: pointer;
}
.footer .footmain .baseinfo .infocontent p {
	color: #ece9e9;
	margin-top: 20px;
	font-size: 14px;
	cursor: pointer;
	width: 100%;
}
.footer .footmain .footerLine {
	width: 100%;
	height: 1px;
	opacity: 0.2;
	background: rgba(0, 0, 0, 0);
	border-bottom: 1px solid #ffffff;
}
.footer .footmain .footerinfo {
	width: 100%;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.footer .footmain .footerinfo span {
	color: rgb(255, 255, 255);
	font-size: 12px;
}
.footerContent {
	width: 100%;
	margin: 0 auto;
	color: white;
	overflow: hidden;
	font-size: 14px;
}
.footerContentMenu {
	width: 100%;
	height: 50px;
	line-height: 50px;
	text-align: center;
}
.footerContentMenu_list {
	display: inline-block;
	width: 100px;
	height: 18px;
	line-height: 18px;
	text-align: center;
	border-right: 1px solid white;
	cursor: pointer;
}
.footerContentMenu_list:last-child {
	border-right: none;
}
.footerContent_list {
	width: 100%;
	height: 35px;
	line-height: 35px;
	text-align: center;
}
#seat {
	width: 100%;
	height: 50px;
}
#call {
	color: white;
	margin-top: 0 !important;

	font-size: 17px;
	font-family: ArialMT;
	text-align: center;
	color: #ffffff;
	line-height: 26px;
}
#code {
	text-align: center;
	color: white;
	font-size: 13px;
	margin-top: 10px !important;
}
.phoneFooter {
	display: none;
	width: 100%;
	background: rgb(84, 120, 185);
	padding: 20px 0;
}
.phoneFooter .phoneWeixin {
	width: 100%;
	height: 98px;
	display: flex;
	margin: 0 auto;
	justify-content: center;
}
.phoneFooter .phoneWeixin img {
	margin: 0 10px;
}
.phoneFooter .phoneFooterInfo {
	width: 100%;
	height: auto;
	text-align: center;
}
.phoneFooter .phoneFooterInfo span {
	color: rgb(255, 255, 255);
	font-size: 12px;
}
.phoneFooter .phoneLine {
	width: 100%;
	height: 1px;
	opacity: 0.2;
	background: rgba(0, 0, 0, 0);
	border-bottom: 1px solid #ffffff;
}
.phoneFooter .phoneLink {
	width: 100%;
	height: 50px;
	text-align: center;
}
.phoneFooter .phoneLink span {
	color: rgb(255, 255, 255);
	font-size: 14px;
	line-height: 50px;
	margin: 0 2px;
}

@media screen and (max-width: 1200px) {
	.footmain {
		display: none;
	}
	.phoneFooter {
		display: block;
	}
	.footerShow {
		padding-bottom: 70px;
	}
	.phoneBottom {
		display: block;
	}
}
</style>
<script>
import axios from 'axios'
import { getFriend } from '@/api/apiCenter'
export default {
	data() {
		return {
			menuList: [],
			linkList: [],
			mainFlage: false
		}
	},
	mounted() {
		this.init()
		this.getLinkList()
		this.$EventBus.$on('setClass', () => {
			this.setClass()
		})
		setTimeout(() => {
			this.setClass()
		}, 100)
	},
	beforeDestroy() {
		this.$EventBus.$off('setClass')
	},

	methods: {
		getLinkList() {
			// axios
			//   .get('http://www.thingo.com.cn/thingo-server/website/friendship/link')
			//   .then((res) => {
			//     this.linkList = res.data.data
			//     this.linkList.forEach((item) => {
			//       if (item.url.slice(0, 1) != 'h') {
			//         item.url = 'https://' + item.url
			//       }
			//     })
			//   })
			getFriend().then(res => {
				this.linkList = res.data.data
				this.linkList.forEach(item => {
					if (item.url.slice(0, 1) != 'h') {
						item.url = 'https://' + item.url
					}
				})
			})
		},
		openDel() {
			this.$EventBus.$emit('openDel')
		},
		init() {
			let that = this
			this.setClass()
			axios.get('/getMenu').then(res => {
				that.menuList = res.data.data
			})
		},
		setClass() {
			if (this.$route.fullPath == '/home/index') {
				this.mainFlage = true
			} else {
				this.mainFlage = false
			}

			if (
				this.$route.fullPath == '/pull/login' ||
				this.$route.fullPath == '/pull/regiester'
			) {
				let footer = document.getElementsByClassName('footer')[0]
				footer.style.display = 'none'
			} else {
				let footer = document.getElementsByClassName('footer')[0]
				footer.style.display = 'block'
			}
		},
		goCenter() {
			document.body.scrollTop = 800
			document.documentElement.scrollTop = 800
			window.pageXOffset = 800
		},
		goTop() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
			window.pageXOffset = 0
		},
		phineLink(url) {
			this.$router.push(url)
			setTimeout(() => {
				this.$EventBus.$emit('setClass')
			}, 100)
		},
		goLink(url, type, ismain, index, title, id) {
			//url 跳转地址
			//type 类型 0公司主营 1客户案例 2走进思高 3新闻中心 4加入我们
			//ismain 是否为主标题 1是 0否
			//index 下标号
			//title 标题
			console.log(url)
			if (id != undefined) {
				this.$router.push({ path: url, query: { sid: id } })
			} else {
				this.$router.push(url)
			}

			// setTimeout(() => {
			//   if (type === 0) {
			//     if (ismain === 1) {
			//       this.$EventBus.$emit('navMainChange', title)
			//       this.$EventBus.$emit('initMainStyle', index - 1)
			//       this.goTop()
			//     } else {
			//       this.$EventBus.$emit('navMainChange', title)
			//       this.$EventBus.$emit('initMainStyle', index - 1)
			//       this.goCenter()
			//     }
			//   } else if (type === 1) {
			//     if (ismain === 1) {
			//       this.$EventBus.$emit('navCaseChange', title)
			//       this.$EventBus.$emit('initCaseStyle', index - 1)
			//       this.goTop()
			//     } else {
			//       this.$EventBus.$emit('navCaseChange', title)
			//       this.$EventBus.$emit('initCaseStyle', index - 1)
			//       this.goCenter()
			//     }
			//   } else if (type === 2) {
			//     if (ismain === 1) {
			//       this.$EventBus.$emit('navChange', title)
			//       this.$EventBus.$emit('initStyle', index - 1)
			//       this.goTop()
			//     } else {
			//       this.$EventBus.$emit('navChange', title)
			//       this.$EventBus.$emit('initStyle', index - 1)
			//       this.goCenter()
			//     }
			//   } else if (type === 3) {
			//     if (ismain === 1) {
			//       this.goTop()
			//     } else {
			//       this.goCenter()
			//     }
			//   } else if (type === 4) {
			//     if (ismain === 1) {
			//       this.$EventBus.$emit('navJoinChange', title)
			//       this.$EventBus.$emit('initJoinStyle', index - 1)
			//       this.goTop()
			//     } else {
			//       this.$EventBus.$emit('navJoinChange', title)
			//       this.$EventBus.$emit('initJoinStyle', index - 1)
			//       this.goCenter()
			//     }
			//   }

			//   this.$EventBus.$emit('selectTab', type + 1)
			//   sessionStorage.index = type + 1
			// }, 100)
		},
		goIndex(index) {
			this.$EventBus.$emit('selectTab', index)
			this.$router.push('/')
			this.goTop()
		},
		goLinkWork() {
			// window.location.href = "https://beian.miit.gov.cn/";
			window.open('https://beian.miit.gov.cn/')
		}
		//点击底部菜单
		// menuClick(index){
		//         let that=this;
		//     let clist = that.menuList[index];
		//     that.$router.push({path:clist.url})
		// },
	}
}
</script>
